import Repository from './repository'

const resource = '/ai'

export default {
  // Chat endpoints
  sendMessage(data) {
    return Repository.post(`${resource}/chat`, data)
  },

  getConversations() {
    return Repository.get(`${resource}/conversations`)
  },

  getConversation(id) {
    return Repository.get(`${resource}/conversations/${id}`)
  },

  deleteConversation(id) {
    return Repository.delete(`${resource}/conversations/${id}`)
  },

  getContext() {
    return Repository.get(`${resource}/context`)
  },

  // Training generation endpoints (coaches only)
  getStudents() {
    return Repository.get(`${resource}/students`)
  },

  generateTraining(data) {
    return Repository.post(`${resource}/generate-training`, data)
  },

  saveTraining(data) {
    return Repository.post(`${resource}/save-training`, data)
  },
}
